export default "__VITE_ASSET__1b1d206e__"